// Регион зрителя для правил показа видео (compliance.region_restriction.blocked чтит КЛИЕНТ).
// Telegram страну не передаёт; webview не знает геолокации без запроса. Оценка — по часовому поясу устройства:
// у Индии (основная аудитория) он единственный — Asia/Kolkata. Незнакомый пояс → null (регион неизвестен).
const ZONES: Record<string, string> = {
  'Asia/Kolkata': 'IN', 'Asia/Calcutta': 'IN',
  'Asia/Karachi': 'PK', 'Asia/Dhaka': 'BD', 'Asia/Colombo': 'LK', 'Asia/Kathmandu': 'NP',
};

export function viewerRegion(timeZone: string | undefined = Intl.DateTimeFormat().resolvedOptions().timeZone): string | null {
  return (timeZone && ZONES[timeZone]) || null;
}

/**
 * Можно ли показывать ролик. Регион известен и в списке blocked → нельзя.
 * Регион неизвестен → показываем: ролик открывается в самом YouTube (не встраивается), и региональный запрет
 * YouTube применяет сам. (08.10: все 5 роликов хаба закрыты для IN — правило «неизвестен = скрыть» прятало всё.)
 * Решение вынесено владельцу на подтверждение.
 */
export function videoAllowed(blocked: string[] | undefined | null, region: string | null): boolean {
  if (!blocked?.length || !region) return true;
  return !blocked.includes(region);
}
